// Quick Settings tunable: a labelled numeric value block.
//
// The editable value field is named EXACTLY 'VALUE' (AC16 guard). Modal-driven writes target
// `block.setFieldValue(v, 'VALUE')` and never collide with the tradeOptions-watched field names
// (SYMBOL_LIST, TRADETYPE_LIST, DURATIONTYPE_LIST, BARRIEROFFSETTYPE_LIST, ...) that
// tradeOptions.js:109-139 reacts to. The apply batch additionally wraps every setFieldValue in
// Blockly.Events.disable()/enable() (apply.js), so even the unguarded tradeOptions onchange stays
// dormant during an Apply.
//
// Pattern: before_purchase/purchase.js:7-24 + trade/components.js:186-224 (raw fields).
import { translate } from '../../../../../common/i18n';
import theme from '../../theme';

Blockly.Blocks.number_input = {
    init: function init() {
        this.appendDummyInput()
            .appendField(new Blockly.FieldTextInput(translate('Label')), 'LABEL')
            .appendField(new Blockly.FieldNumber(0), 'VALUE');
        this.setOutput(true, 'Number');
        this.setColour(theme.subBlockColor);
        this.setTooltip(translate('A numeric value editable from Quick Settings.'));
    },
};

Blockly.JavaScript.number_input = block => {
    const value = block.getFieldValue('VALUE');
    return [String(value), Blockly.JavaScript.ORDER_ATOMIC];
};
